import React from "react";
import Navbar2 from "../components/Navbar2";

const UserAgreement = () => {
  return (
    <section>
      <Navbar2 />

      <section className="padding ">
        <section className="md:w-[850px] w-full mx-auto  pb-[3rem]">
          <h1 className="volkhov text-center md:text-[30px] xs:text-[25px] text-[22px] xs:leading-[35px] leading-[25px] xs:pt-[20px] pt-[10px] text-tertiary">
            End User Agreement and Terms of Use for Starbites Food Delivery
            application{" "}
          </h1>

          <p className="xs:mt-[20px] mt-[10px] w-full inter xs:text-[16px] text-[15px] text-primary">
            Welcome to the Starbites App! By downloading, installing, or using
            this app to order food and delivery, you agree to be bound by these
            Terms of Use. If you do not agree, please do not use the app.{" "}
          </p>

          <h2 className="xs:text-[20px] text-[18px] xs:mt-[20px] mt-[10px] inter font-[500] text-tertiary">
            1. Acceptance of Terms
          </h2>
          <p className="mt-[6px] w-full inter xs:text-[16px] text-[15px] text-primary">
            By accessing and using the Starbites App, you agree to comply with
            and be legally bound by these Terms of Use and our Privacy Policy.
            These terms apply to all visitors, users, and others who access or
            use the app.
          </p>

          <h2 className="xs:text-[20px] text-[18px] xs:mt-[20px] mt-[10px] inter font-[500] text-tertiary">
            2. User Accounts
          </h2>
          <ul className="xs:ml-[2rem] ml-[1rem]">
            <li className="mt-[6px] w-full inter xs:text-[16px] text-[15px] text-primary">
              You must create an account to use certain features of the app,
              such as ordering food and delivery.
            </li>
            <li className="mt-[3px] w-full inter xs:text-[16px] text-[15px] text-primary">
              You are responsible for maintaining the confidentiality of your
              account and password.
            </li>
            <li className="mt-[3px] w-full inter xs:text-[16px] text-[15px] text-primary">
              You agree to accept responsibility for all activities that occur
              under your account.
            </li>
            <li className="mt-[3px] w-full inter xs:text-[16px] text-[15px] text-primary">
              You must provide accurate and complete information when creating
              an account and using the app.
            </li>
          </ul>

          <h2 className="xs:text-[20px] text-[18px] xs:mt-[20px] mt-[10px] inter font-[500] text-tertiary">
            3. Use of the App
          </h2>
          <ul className="xs:ml-[2rem] ml-[1rem]">
            <li className="mt-[6px] w-full inter xs:text-[16px] text-[15px] text-primary">
              The app is intended for personal use only. You agree to use the
              app only for lawful purposes and in accordance with these Terms.
            </li>
            <li className="mt-[3px] w-full inter xs:text-[16px] text-[15px] text-primary">
              You may not use the app in any way that could damage, disable,
              overburden, or impair our servers or networks.
            </li>
            <li className="mt-[3px] w-full inter xs:text-[16px] text-[15px] text-primary">
              You agree not to attempt to gain unauthorized access to any part
              of the app, other accounts, or systems connected to the app.
            </li>
          </ul>

          <h2 className="xs:text-[20px] text-[18px] xs:mt-[20px] mt-[10px] inter font-[500] text-tertiary">
            4. Ordering and Payment
          </h2>
          <ul className="xs:ml-[2rem] ml-[1rem]">
            <li className="mt-[6px] w-full inter xs:text-[16px] text-[15px] text-primary">
              By placing an order through the app, you agree to pay for the full
              amount specified at the time of order.
            </li>
            <li className="mt-[3px] w-full inter xs:text-[16px] text-[15px] text-primary">
              Prices and availability of menu items are subject to change
              without notice.
            </li>
            <li className="mt-[3px] w-full inter xs:text-[16px] text-[15px] text-primary">
              All payments must be made through the app using the provided
              payment methods.
            </li>
          </ul>
          <h2 className="xs:text-[20px] text-[18px] xs:mt-[20px] mt-[10px] inter font-[500] text-tertiary">
            5. Delivery
          </h2>
          <ul className="xs:ml-[2rem] ml-[1rem]">
            <li className="mt-[6px] w-full inter xs:text-[16px] text-[15px] text-primary">
              Delivery times are estimates and may vary due to factors beyond
              our control.
            </li>
            <li className="mt-[3px] w-full inter xs:text-[16px] text-[15px] text-primary">
              You agree to provide accurate delivery information and be
              available to receive your order at the specified time and
              location.
            </li>
          </ul>
          <h2 className="xs:text-[20px] text-[18px] xs:mt-[20px] mt-[10px] inter font-[500] text-tertiary">
            6. Intellectual Property
          </h2>
          <ul className="xs:ml-[2rem] ml-[1rem]">
            <li className="mt-[6px] w-full inter xs:text-[16px] text-[15px] text-primary">
              All content, features, and functionality of the app are the
              exclusive property of Starbites and its licensors.
            </li>
            <li className="mt-[3px] w-full inter xs:text-[16px] text-[15px] text-primary">
              You may not reproduce, distribute, modify, or create derivative
              works of any content without our written permission.
            </li>
          </ul>
          <h2 className="xs:text-[20px] text-[18px] xs:mt-[20px] mt-[10px] inter font-[500] text-tertiary">
            7. Termination
          </h2>
          <ul className="xs:ml-[2rem] ml-[1rem]">
            <li className="mt-[6px] w-full inter xs:text-[16px] text-[15px] text-primary">
              We reserve the right to suspend or terminate your access to the
              app at any time, without notice, for any reason, including
              violation of these Terms.
            </li>
          </ul>
          <h2 className="xs:text-[20px] text-[18px] xs:mt-[20px] mt-[10px] inter font-[500] text-tertiary">
            8. Limitation of Liability
          </h2>
          <ul className="xs:ml-[2rem] ml-[1rem]">
            <li className="mt-[6px] w-full inter xs:text-[16px] text-[15px] text-primary">
              Starbites shall not be liable for any indirect, incidental,
              special, consequential, or punitive damages, including loss of
              profits, data, or use, arising from your use of the app.
            </li>
            <li className="mt-[3px] w-full inter xs:text-[16px] text-[15px] text-primary">
              Our liability for direct damages arising from your use of the app
              is limited to the total amount paid by you for the order in
              question.
            </li>
          </ul>
          <h2 className="xs:text-[20px] text-[18px] xs:mt-[20px] mt-[10px] inter font-[500] text-tertiary">
            9. Changes to the Terms
          </h2>
          <ul className="xs:ml-[2rem] ml-[1rem]">
            <li className="mt-[6px] w-full inter xs:text-[16px] text-[15px] text-primary">
              We reserve the right to modify these Terms at any time. We will
              notify you of any changes by posting the new Terms on the app.
              Your continued use of the app after any such changes constitutes
              your acceptance of the new Terms.
            </li>
          </ul>
          <h2 className="xs:text-[20px] text-[18px] xs:mt-[20px] mt-[10px] inter font-[500] text-tertiary">
            10. Governing Law
          </h2>
          <ul className="xs:ml-[2rem] ml-[1rem]">
            <li className="mt-[6px] w-full inter xs:text-[16px] text-[15px] text-primary">
              These Terms shall be governed and construed in accordance with the
              laws of Ghana, without regard to its conflict of law provisions.
            </li>
          </ul>
          <h2 className="xs:text-[20px] text-[18px] xs:mt-[20px] mt-[10px] inter font-[500] text-tertiary">
            11. Contact Information
          </h2>
          <ul className="xs:ml-[2rem] ml-[1rem]">
            <li className="mt-[6px] w-full inter xs:text-[16px] text-[15px] text-primary">
              If you have any questions about these Terms, please contact us at
              Starbites [info@starbitesgh.com].
            </li>
          </ul>
        </section>
      </section>
    </section>
  );
};

export default UserAgreement;
